var exports = {
  "iE": "x61f99309--6f0599--wrapper",
  "Sl": "x61f99309--6f0599--image",
  "pq": "x61f99309--6f0599--info",
};

module.exports = exports;
